module.exports = __webpack_public_path__ + "img/taxi.c31aadbb.png";